import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const YELLOW = '#ffcc00';
const BLACK = '#000000';
const WHITE = '#ffffff';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAboutClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const aboutSection = document.getElementById('uber-uns');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const aboutSection = document.getElementById('uber-uns');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: 'Startseite', path: '/', isRoute: true },
  
    { name: 'Unsere Leistungen', path: '/leistungen', isRoute: true },
    { name: 'Kontakt', path: '/kontakt', isRoute: true }
  ];

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
          background-color: #000;
        }
        
        @media (max-width: 968px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
        
        @media (min-width: 969px) {
          .mobile-menu-btn { display: none !important; }
          .mobile-menu { display: none !important; }
        }
      `}</style>

      {/* Navigation Header */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: BLACK,
        padding: '20px 60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1000,
        transition: 'all 0.3s ease',
        boxShadow: isScrolled ? '0 2px 10px rgba(0,0,0,0.3)' : 'none'
      }}>
        
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '15px', textDecoration: 'none' }}>
          <div style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            border: `3px solid ${YELLOW}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: BLACK
          }}>
            <svg style={{ width: '26px', height: '26px', fill: YELLOW }} viewBox="0 0 24 24">
              <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
            </svg>
          </div>
          <div>
            <div style={{
              fontSize: '20px',
              fontWeight: 900,
              color: YELLOW,
              letterSpacing: '1px',
              textTransform: 'uppercase',
              lineHeight: 1.1
            }}>AUTO HOBBY</div>
            <div style={{
              fontSize: '13px',
              fontWeight: 600,
              color: WHITE,
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginTop: '2px'
            }}>WERKSTATT</div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '50px'
        }}>
          {navLinks.map((link, i) => (
            link.isRoute ? (
              <Link
                key={i}
                to={link.path}
                style={{
                  color: WHITE,
                  textDecoration: 'none',
                  fontSize: '15px',
                  fontWeight: 500,
                  letterSpacing: '0.3px',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = YELLOW}
                onMouseLeave={(e) => e.target.style.color = WHITE}
              >
                {link.name}
              </Link>
            ) : (
              <a
                key={i}
                href={link.path}
                onClick={handleAboutClick}
                style={{
                  color: WHITE,
                  textDecoration: 'none',
                  fontSize: '15px',
                  fontWeight: 500,
                  letterSpacing: '0.3px',
                  transition: 'color 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.color = YELLOW}
                onMouseLeave={(e) => e.target.style.color = WHITE}
              >
                {link.name}
              </a>
            )
          ))}
          
         
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          style={{
            display: 'none',
            flexDirection: 'column',
            gap: '6px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          <div style={{
            width: '28px',
            height: '3px',
            backgroundColor: YELLOW,
            transition: 'all 0.3s',
            transform: isMobileMenuOpen ? 'rotate(45deg) translateY(9px)' : 'none'
          }} />
          <div style={{
            width: '28px',
            height: '3px',
            backgroundColor: YELLOW,
            transition: 'all 0.3s',
            opacity: isMobileMenuOpen ? 0 : 1
          }} />
          <div style={{
            width: '28px',
            height: '3px',
            backgroundColor: YELLOW,
            transition: 'all 0.3s',
            transform: isMobileMenuOpen ? 'rotate(-45deg) translateY(-9px)' : 'none'
          }} />
        </button>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu" style={{
          position: 'fixed',
          top: '90px',
          left: 0,
          right: 0,
          backgroundColor: BLACK,
          padding: '30px 40px',
          zIndex: 999,
          borderTop: `1px solid ${YELLOW}`
        }}>
          {navLinks.map((link, i) => (
            link.isRoute ? (
              <Link
                key={i}
                to={link.path}
                style={{
                  display: 'block',
                  color: WHITE,
                  textDecoration: 'none',
                  fontSize: '18px',
                  fontWeight: 500,
                  padding: '18px 0',
                  borderBottom: '1px solid rgba(255, 204, 0, 0.15)',
                  transition: 'color 0.3s ease'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
                onMouseEnter={(e) => e.target.style.color = YELLOW}
                onMouseLeave={(e) => e.target.style.color = WHITE}
              >
                {link.name}
              </Link>
            ) : (
              <a
                key={i}
                href={link.path}
                onClick={handleAboutClick}
                style={{
                  display: 'block',
                  color: WHITE,
                  textDecoration: 'none',
                  fontSize: '18px',
                  fontWeight: 500,
                  padding: '18px 0',
                  borderBottom: '1px solid rgba(255, 204, 0, 0.15)',
                  transition: 'color 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.color = YELLOW}
                onMouseLeave={(e) => e.target.style.color = WHITE}
              >
                {link.name}
              </a>
            )
          ))}
         
        </div>
      )}
    </>
  );
};

export default Header;